import type { HandoffBatchPreview } from '../../../types/adaptationWorkbench';

/** Shared with `pushStripOf`; the Book must never invent another preview-error sentence. */
export const PREVIEW_ERROR_LINE = 'chưa tính được kế hoạch — máy chủ vẫn kiểm lại khi đẩy';
export type PreviewLineStatus = 'idle' | 'loading' | 'error' | 'ok';
export const previewLineOf = (status: PreviewLineStatus): string | null =>
  status === 'loading' ? 'đang kiểm tra trước khi đẩy' : status === 'error' ? PREVIEW_ERROR_LINE : null;
export const previewBarView = (status: PreviewLineStatus): { line: string | null; showRetry: boolean } => ({ line: previewLineOf(status), showRetry: status === 'error' });
/** A stale successful handoff plan must not unlock the heavy preview after refresh. */
export const previewReadyForPlan = (planStatus: 'ok' | 'loading' | 'unknown', planVersion: number | null, dataVersion: number): boolean => planStatus === 'ok' && planVersion === dataVersion;

export type PreviewOverlay =
  | { kind: 'notEligible'; code: string; reason: string; blockedBy?: number }
  | { kind: 'scriptChanged'; reason: string };

export interface SkipRowView { sentence: string; button: { label: string; episode: number } }
/** Target must be derived once: label and click cannot diverge for RANGE_NOT_READY. */
export const skipRowView = (code: string | null | undefined, reason: string | null | undefined, episode: number, blockedBy?: number): SkipRowView => {
  const target = code === 'RANGE_NOT_READY' && Number.isInteger(blockedBy) && (blockedBy as number) > 0 ? blockedBy as number : episode;
  return { sentence: reason?.trim() || 'Chưa sẵn sàng', button: { label: `Mở tập ${target}`, episode: target } };
};

export const skippedFromPreview = (episodes: HandoffBatchPreview['episodes'] | null | undefined): Map<number, PreviewOverlay> => {
  const out = new Map<number, PreviewOverlay>();
  for (const item of episodes ?? []) {
    if (item.action === 'skipped_not_eligible') out.set(item.episode, { kind: 'notEligible', code: item.code ?? 'UNKNOWN', reason: item.reason ?? 'Chưa sẵn sàng', ...(item.blockedBy !== undefined ? { blockedBy: item.blockedBy } : {}) });
    if (item.action === 'skipped_script_changed') out.set(item.episode, { kind: 'scriptChanged', reason: item.reason ?? `Tập ${item.episode} đã đổi từ lúc bạn xem` });
  }
  return out;
};

export const sourceNameSuffix = (names: ReadonlyArray<unknown> | null | undefined): string => {
  const n = names?.length ?? 0;
  return n > 5 ? ` … và ${n - 5} tên khác` : '';
};
